<template>
	<loading-icon class="c-card" v-if="loading"></loading-icon>
  <section class="c-card c-card--tier" v-else>
    <div class="c-card--tier__left c-card--tier__summary">
      <img
          v-if="card.level && card.level.image" 
          :src="card.level.image.url"
          class="c-card--tier__summary__img qa-tier-image"
      /> 

      <div class="c-card--tier__summary__text">
        <h2 
          v-if  = "card.title"
          class = "c-card--tier__summary__text__title t-tier-title qa-tier-title"
        >
          {{ card.title }}
        </h2>

        <h3 class="c-card--tier__summary__text__sub qa-tier-level" :style="levelColor">
          {{ card.level ? card.level.name : '' }}
        </h3>
      </div>
    </div>




    <div v-if="card.level" class="c-card--tier__right">
      <div v-if="card.level.is_top_tier" class="c-card--tier__top-tier-details">
        <div class="c-card---tier__top-tier-details__text">
          <div 
            v-html = "card.level.message" 
            class  = "c-card---tier__top-tier-details__text__message qa-tier-message"
          ></div>
          
          <a
            :href = "card.level.link.url" 
            v-if  = "card.level.link" 
            class = "c-card---tier__top-tier-details__link u-no-wrap qa-tier-link js-handle-link" 
          >
            {{ card.level.link.text }}
            &raquo;
          </a>
        </div>
      </div>


      <div v-else>
        <div class="c-card--tier__progress-wrapper">
          <h4 
            v-if   = "progressValues"
            :style = "levelColor"
            class  = "c-card--tier__progress-wrapper__left
                      c-card--tier__progress-value 
                      t-tier-progress-text
                      qa-tier-progress"
          >
            {{ progressValues }}
          </h4>

          <div class="c-card--tier__progress-bar">
            <div 
              class  = "c-card--tier__progress-bar__progress t-tier-progress-bar"
              :style = "progressBarStyle"
            ></div>
          </div>
        </div>

        <div class="c-card---tier__details__text">
          <span 
            v-html = "card.level.message" 
            class  = "c-card---tier__details__text__message qa-tier-message"
          ></span>

          <a
            :href = "card.level.link.url" 
            v-if  = "card.level.link" 
            class = "c-card---tier__details__text__link u-no-wrap qa-tier-link js-handle-link" 
          >
            {{ card.level.link.text }}
            &raquo;
          </a>
        </div>
      </div>
    </div>
  </section>
</template>




<script>
import { mapGetters } from 'vuex'
import $ from 'jquery'
import { isNil } from 'lodash'
import util from '@/functions'

export default {
  props: ['card'],
  computed: {
    ...mapGetters([
      'websiteConfig'
    ]),
    loading () {
      return !this.card.cardLoaded
    },
    /**
     * Returns the current progress towards the goal either as a single percentage number
     * or as a set of 'progress / goal' numbers, based on the tier 'display' property
     *
     * @returns null|string
     */
    progressValues () {
      if (isNil(this.card.level)) {
        return null
      }
      if (this.card.level.display === 'percentage') {
        return this.card.level.percentage
      }
      return util.formatNumber(this.card.level.formatted_progress) + ' / ' +
        util.formatNumber(this.card.level.formatted_goal)
    },
    /**
     * Returns a css styles object with the level color if defined for the current level
     *
     * @returns {Object}
     */
    levelColor () {
      return !isNil(this.card.level) && !isNil(this.card.level.color)
        ? { color: this.card.level.color }
        : {}
    },
    /**
     * Returns a css styles object for the progress bar (width/color/etc)
     *
     * @returns {Object}
     */
    progressBarStyle () {
      let style = {}
      if (!isNil(this.card.level)) {
        style.width = this.card.level.percentage
      }
      if (!isNil(this.card.level) && !isNil(this.card.level.color)) {
        style.background = this.card.level.color
      }
      return style
    }
  },
  mounted () {
    $(this.$el).find('a.js-handle-link').off('click')
    $(this.$el).find('a.js-handle-link').on('click', this.handleLink)
  },
  updated () {
    $(this.$el).find('a.js-handle-link').off('click')
    $(this.$el).find('a.js-handle-link').on('click', this.handleLink)
  },
  methods: {
    handleLink (e) {
      util.handleLink(e, this.websiteConfig, this.$router)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Tier.vue?758ba0ee